module.exports = __webpack_public_path__ + "Server-Healthy.Kubernetes.a91f69fdde030bc73274d6581af86d3c.hashedasset.svg";